/* eslint-disable */

import * as THREE from 'three'
import PolygoneTexture from './PolygoneTexture.js'
import PointOfInterestParticlesShader from './Shaders/PointOfInterestParticles.js'

class PointOfInterest
{
    /**
     * Constructor
     */
    constructor(options)
    {
        // Options
        this.time = options.time

        // Container
        this.container = new THREE.Object3D()

        // Particles
        this.setPolygones()
        this.setParticles()
    }

    /**
     * Set polygones
     */
    setPolygones()
    {
        // Red
        const polygoneTexture = new PolygoneTexture({
            debug: false,
            resolution: 128,
            shapes:
            [
                {
                    edgesCount: 6,
                    radius: 52,
                    angle: Math.PI * 2 / 12,
                    strokeStyle: '#cc0000',
                    lineWidth: 12
                },
                {
                    edgesCount: 6,
                    radius: 26,
                    angle: Math.PI * 2 / 12,
                    strokeStyle: '#ffffff',
                    lineWidth: 8
                }
            ]
        })
        polygoneTexture.texture.needsUpdate = true

        const geometry = new THREE.PlaneBufferGeometry(0.04, 0.04, 1, 1)
        const material = new THREE.MeshBasicMaterial({ map: polygoneTexture.texture, side: THREE.DoubleSide, transparent: true })
        this.planeMesh = new THREE.Mesh(geometry, material)

        this.container.add(this.planeMesh)
    }

    /**
     * Set particles
     */
    setParticles()
    {
        this.particles = {}
        this.particles.count = 150
        this.particles.elevation = 0.12

        // Attributes
        this.particles.attributes = {}
        this.particles.attributes.positions = new Float32Array(this.particles.count * 3)

        let i = 0

        while(i < this.particles.count)
        {
            this.particles.attributes.positions[i * 3 + 0] = 0
            this.particles.attributes.positions[i * 3 + 1] = 0
            this.particles.attributes.positions[i * 3 + 2] = - i / this.particles.count * this.particles.elevation

            i++
        }

        // Uniforms
        this.particles.uniforms = {
            uRandomSeed: { value: Math.random() },
            uTime: { value: 0 },
            uAlpha: { value: 1.25 },
            uSize: { value: 0.014 },
            uSmoothness: { value: 0.3 },
            uColor: { value: new THREE.Color(0x663333) },
            uElevation: { value: this.particles.elevation },
            uSpeed: { value: 0.0000012 },
            uBlur: { value: new THREE.Vector3(0.002, 5.0, 1.5) }, // Distance / Size strength / Smoothness strength
        }

        // Material
        this.particles.material = new THREE.ShaderMaterial({
            uniforms: this.particles.uniforms,
            vertexShader: PointOfInterestParticlesShader.vertexShader,
            fragmentShader: PointOfInterestParticlesShader.fragmentShader,
            blending: THREE.AdditiveBlending,
            depthTest: false,
            transparent: true
        })

        // Geometry
        this.particles.geometry = new THREE.BufferGeometry()
        this.particles.geometry.addAttribute('position', new THREE.BufferAttribute(this.particles.attributes.positions, 3))

        // Points
        this.particles.points = new THREE.Points(this.particles.geometry, this.particles.material)

        // Add
        this.container.add(this.particles.points)
    }

    /**
     * Update
     */
    update()
    {
        this.particles.uniforms.uTime.value = this.time.current
    }
}

export default PointOfInterest


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/PointOfInterest.js